export enum BenefitWizardType {
    None = 'None',
    Add = 'Add',
    BuyUp = 'BuyUp',
    Term = 'Term',
    Waive = 'Waive',
    WaiveBenefit = 'WaiveBenefit',
    FSA = 'FSA',
    Widget = 'Widget',
    Cancel = 'Cancel',
    Checkout = 'Checkout',
    Keep = 'Keep',
}

export enum BenefitOnboardWizardPanel {
    initialize = 'Initialize',
    skip = 'Skip',
    modeSelection = 'ModeSelection',
    profile = 'Profile',
    enrollmentIntro = 'EnrollmentIntro',
    qualifyingEvent = 'QualifyingEvent',
    requestReview = 'RequestReview',
    autoOnboarding = 'AutoOnboarding',
}

export enum BenefitAddWizardPanel {
    none = 'None',
    benefits = 'Benefits',
    futureBenefits = 'FutureBenefits',
    kitBenefits = 'KitBenefits',
    coreBenefits = 'CoreBenefits',
    autoEnroll = 'AutoEnroll',
    tobacco = 'Tobacco',
    coverage = 'Coverage',
    eligibility = 'Eligibility',
    additionalInfo = 'AdditionalInfo',
    pcp = 'Pcp',
    beneficiary = 'Beneficiary',
    autoTerm = 'AutoTerm',
    requestTerm = 'RequestTerm',
    dpDisclaimer = 'DpDisclaimer',
    disclaimer = 'Disclaimer',
    summary = 'Summary',
    futureBenefitsDisclaimer = 'FutureBenefitsDisclaimer',
    finalize = 'Finalize',
}

/**
 * OptionalBenefits are KitBenefits
 */
export enum BenefitBuyupWizardPanel {
    none = 'None', 
    benefits = 'Benefits',
    optionalBenefits = 'OptionalBenefits',
    coreBenefits = 'CoreBenefits',
    // additionalBenefits = 'AdditionalBenefits',
    tobacco = 'Tobacco',
    coverage = 'Coverage',
    eligibility = 'Eligibility',
    additionalInfo = 'AdditionalInfo',
    pcp = 'Pcp',
    beneficiary = 'Beneficiary',
    autoTerm = 'AutoTerm',
        requestTerm = 'RequestTerm',
    dpDisclaimer = 'DpDisclaimer',
    disclaimer = 'Disclaimer',
    summary = 'Summary',
    finalize = 'Finalize',
}

export enum BenefitTerminateWizardPanel {
    none = 'None',
    benefits = 'Benefits',
    autoTerm = 'AutoTerm',
    requestTerm = 'RequestTerm',
    summary = 'Summary',
    finalize = 'Finalize',
}

export enum BenefitCancelWizardPanel {
    none = 'None',
    requests = 'Requests',
    summary = 'Summary',
    finalize = 'Finalize',
}

export enum BenefitWaiveWizardPanel {
    none = 'None',
    finalize = 'Finalize',
}

export enum BenefitWidgetWizardPanel {
    none = 'none',
    error = 'error',
    finalize = 'finalize',
}

export enum BenefitCheckoutWizardPanel {
    none = 'None',
    pcnaDependent = 'PolyConceptDependentAffirmation',
    dependentSSN = 'DependentSSN',
    dependentVerify = 'DependentVerify',
    waiveDocuments = 'WaiveDocuments',
    usaePay = 'USAePay',
    documents = 'Documents',
    requiredLiterature = 'Required Literature',
    spouseSurcharge = 'SpouseSurcharge',
    spouseExclusion = 'SpouseExclusion',
    smokerSurcharge = 'SmokerSurcharge',
    autoEnroll = 'AutoEnroll',
    adminEvent = 'AdminEvent',
    beneficiaries = 'Beneficiaries',
    summary = 'Summary',
    finalize = 'Finalize',
    complete = 'Complete',
}

export enum ReportWizardPanel {
    initialize = 'Initialize',
    company = 'Company',
    templates = 'Templates',
    parameters = 'Parameters',
    detail = 'Detail',
    summary = 'Summary',
    finalize = 'Finalize',
}

export enum ReportParamterType {
    openEnrollment = 'Open Enrollment',
    benefitCategories = 'Benefit Categories',
    date = 'Date',
}